import styled from '@emotion/styled';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';

export const StyledBadge = styled('div')`
  ${styleUtils.flex.container({ inline: true })};
  ${styleUtils.base.square({ size: '16px' })};
  border-radius: ${theme.borderRadius.large};
  background-color: ${(props) =>
    props.color || theme.color.designSystem.success};
  vertical-align: middle;
  width: ${(props) => props.count && '24px'};
`;

export const Count = styled('span')`
  ${styleUtils.typography.small({ weight: 'semiBold' })};
  color: ${theme.color.white};
`;
